import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import {
  VehiclePricingRequestAggregations,
  VehiclePricingRequestSearchFilters,
} from "../../types/VehiclePricingRequest";

export const getDealerPricingRequestAggregations = (
  filters: VehiclePricingRequestSearchFilters | null,
  options: APQueryOptions = {}
) => {
  const { nextPageLink, ...otherFilters } = filters || {};
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSuccess, isQueryEnabled } =
    useAPQuery();

  return useQuery({
    queryKey: ["getDealerPricingRequestAggregations", filters],
    queryFn: (): Promise<VehiclePricingRequestAggregations> => {
      return fetchWithAuth<VehiclePricingRequestAggregations>(
        "getDealerPricingRequestAggregations",
        undefined,
        {
          requestOptions: {
            method: "post",
            body: filters
              ? JSON.stringify({
                  ...otherFilters,
                  nextPage: nextPageLink ?? undefined,
                })
              : undefined,
          },
        }
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    enabled: isQueryEnabled(options),
    keepPreviousData: options.keepPreviousData,
  });
};
